﻿function getrecommanded() {
    showWait();
    $.ajax({
        type: 'get',
        async: true,
        url: ROOT + '/lives/recommanded?page=1&size=3&type=0&state=2',
        data: {},
        contentType: 'application/json',
        dataType: 'json',
        success: function (result) {
            if (result) {
                if (result.error == undefined) {
                    var isAdd = false;
                    for (var i = 0; i < result.data.length; i++) {
                        var info = result.data[i];
                        if (info.cover_url == null || info.cover_url.length == 0) {
                            continue;
                        }
                        isAdd = true;

                        var html = '<div class="scrollview-right-item" data-info=\'' + info + '\'>' +
                            '<a target="_blank" href="/room/' + info.id + '">' +
                            '<img src="' + info.cover_url + '?w=295&h=137&s=3">' +
                            '<div class="scrollview-right-item-bk"></div>' +
                            '</a>' +
                            '</div>';
                        $('.scrollview-right').append(html);

                        if (i == 0) {
                            $('#poster-main-a').attr('href', '/room/' + info.id);
                            $('#poster-main-img').attr('src', info.cover_url + '?w=898&h=420&s=3');
                        }
                    }

                    if (isAdd) {
                        $('.scrollview').show();
                    }
                } else {
                    // alert(result.message);
                }
            }
        },
        error: function (XMLHttpRequest, textStatus, errorThrown) {
            // alert(XMLHttpRequest.responseText);
        },
        complete: function (XMLHttpRequest, textStatus) {
            hideWait();
        }
    });
}

// getrecommanded();

gethotest(12);

gethotest2(24);

$('.showtab').click(function () {
    $('.active').removeClass('active');
    $(this).addClass('active');

    if ($(this).data('type') == 2) {
        $('.curentlives').hide();
        $('.curentlives2').show();
    } else {
        $('.curentlives').show();
        $('.curentlives2').hide();
    }
});